// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"8d75df74","527":"93a54074","558":"253ae5cd","705":"70f0473e","897":"bd0c1678"}[chunkId] + ".chunk.js";
};